import { Star } from "lucide-react";

export const GOOGLE_REVIEW_URL = "https://www.google.com/maps?cid=17431886734336458437";

export const ReviewBanner = () => (
  <section className="border-b border-line bg-gold/10" aria-labelledby="review-offer-title" data-testid="review-banner">
    <div className="container-x flex flex-col gap-5 py-8 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex flex-col items-start gap-3 sm:flex-row sm:gap-4">
        <span className="flex shrink-0 gap-0.5 pt-1 text-gold" aria-hidden>{[0, 1, 2, 3, 4].map((i) => <Star key={i} className="h-5 w-5 fill-current" />)}</span>
        <div>
          <h2 id="review-offer-title" className="text-2xl font-semibold text-white sm:text-3xl">Leave us a Google review, get <span className="text-gold">2 FREE prerolls</span> on your next order</h2>
          <p className="mt-2 text-xs text-gray-400" data-testid="review-banner-terms">One per customer. Show your review at delivery or pickup. 21+.</p>
        </div>
      </div>
      <a href={GOOGLE_REVIEW_URL} target="_blank" rel="noopener noreferrer" className="btn-gold shrink-0 px-8" data-testid="review-banner-button">Write a Review</a>
    </div>
  </section>
);
